goog.provide('el8.ptdata.model.med.interactionsDetail');

goog.require('el8.model.base');

el8.ptdata.model.med.interactionsDetail = function(spec) { this.populate(spec); };
el8.ptdata.model.med.interactionsDetail.inheritsFrom(el8_Entity);
el8.ptdata.model.med.interactionsDetail.addStringProperty("ignoreReason");
el8.ptdata.model.med.interactionsDetail.addStringProperty("displayedDrugDrugMajorIntxnMsgs");
el8.ptdata.model.med.interactionsDetail.addStringProperty("displayedDrugAllergyMajorIntxnMsgs");
el8.ptdata.model.med.interactionsDetail.prototype.asSoyMap = function() {
    return {
        ignoreReason: this.getIgnoreReason(),
        displayedDrugDrugMajorIntxnMsgs: this.getDisplayedDrugDrugMajorIntxnMsgs(),
        displayedDrugAllergyMajorIntxnMsgs: this.getDisplayedDrugAllergyMajorIntxnMsgs()
    };
};

